const ONE_SECOND = 1000;
const ONE_MINUTE = 60 * ONE_SECOND;

export const TIME_IN_MS = {
  HALF_SECOND: ONE_SECOND / 2,
  THREE_SECONDS: ONE_SECOND * 3,
  FIVE_SECONDS: ONE_SECOND * 5,
  ONE_MINUTE: ONE_MINUTE,
  FIVE_MINUTES: ONE_MINUTE * 5,
};
